var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share",
    transform: "translate(-218.731 -92.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M225.481,92.9h-3.75a3,3,0,0,0-3,3v9a3,3,0,0,0,3,3h9a3,3,0,0,0,3-3v-3.75a.75.75,0,0,0-1.5,0v3.75a1.5,1.5,0,0,1-1.5,1.5h-9a1.5,1.5,0,0,1-1.5-1.5v-9a1.5,1.5,0,0,1,1.5-1.5h3.75a.75.75,0,0,0,0-1.5Zm5.69,1.5h-2.69a.75.75,0,0,1,0-1.5h4.5a.75.75,0,0,1,.75.75v4.5a.75.75,0,1,1-1.5,0v-2.69l-5.47,5.47a.75.75,0,1,1-1.061-1.061Z",
    fill: "#bbb",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebshare);
export default __webpack_public_path__ + "static/media/webshare.03bfb7a6e55d2016fcd9a9a90b8dfbad.svg";
export { ForwardRef as ReactComponent };